import React, { useState } from 'react';
import { Link }            from 'react-router-dom';
import { getRoute }        from 'pursuit/routes/routes';

export default function Overlay() {
    const [open, setOpen] = useState(true);

    const className = open ? 'open' : 'closed';

    const doClose = () => {
        setOpen(false);
    };

    return (
        <div role="home-overlay" className={className}>
            <div className="overlay-content">
                <p>We are now offering In-Person <span className="strong">AND</span> Virtual Appointments for Chiropractic, Physiotherapy and Naturopathic services.</p>

                <div>
                    <a
                        href="/booking"
                        target="_blank"
                        className="button CTA"
                    >
                        Book An Appointment
                    </a>
                </div>

                <p>We have Gift Cards available.</p>

                <div>
                    <a
                        href="https://pursuit-integrative-health.myshopify.com/"
                        target="_blank"
                        className="button CTA"
                    >
                        Click HERE
                    </a>
                </div>

                <p>To sign up for Pursuit Movement Classes.</p>

                <div>
                    <Link
                        className="button CTA"
                        to={getRoute('pursuitMovement')}
                    >
                        Click HERE
                    </Link>
                </div>

                <span
                    className="closer-btn"
                    onClick={doClose}
                >Close</span>
            </div>
        </div>
    )
}
